import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import type { IFormSectionProps } from '@/@types/photostudio';
import { cn } from '@/lib/utils';

const sectionColorMap = {
  '1': 'text-section-1',
  '2': 'text-section-2',
  '3': 'text-section-3',
  references: 'text-section-references',
} as const;

export function FormSection({
  number,
  title,
  icon: Icon,
  defaultOpen = true,
  children,
  sectionColor,
}: IFormSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // Use section color if provided, otherwise fall back to default styling
  const colorClass = sectionColor
    ? sectionColorMap[sectionColor]
    : number
      ? 'text-foreground'
      : 'text-accent';

  return (
    <CollapsiblePrimitive.Root open={isOpen} onOpenChange={setIsOpen}>
      <CollapsiblePrimitive.Trigger asChild>
        <button type="button" className="flex w-full items-center gap-2.5 cursor-pointer">
          <Icon className={cn('h-[18px] w-[18px]', colorClass)} />
          <span className={cn('text-sm font-semibold uppercase tracking-wider', colorClass)}>
            {number ? `${number}. ${title}` : title}
          </span>
          <ChevronDown
            className={cn(
              'ml-auto h-4 w-4 text-foreground-muted transition-transform duration-200',
              isOpen && 'rotate-180'
            )}
          />
        </button>
      </CollapsiblePrimitive.Trigger>
      <CollapsiblePrimitive.Content className="mt-4 space-y-4">
        {children}
      </CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
}
